module.exports = __webpack_public_path__ + "resources/img/img_vcast.3dee60a9fa648ee18ecf1a5dd48edd9b.png";